'use client'
import { ChevronLeftIcon } from 'lucide-react'
import { useRouter } from 'next/navigation'
import { Button } from '@/components/button'
import { Text } from '@/components/text'

export default function DefaultNotFoundPage(): JSX.Element {
    const router = useRouter()

    return (
        <div className="flex h-full w-full flex-col items-center justify-center">
            <div className="flex flex-wrap items-center gap-4">
                <Text type="title1">404</Text>
                <span className="h-8 w-px bg-neutral-200 dark:bg-neutral-700" />
                <Text type="subtitle1">Pagina non trovata</Text>
            </div>
            <Button
                variant="white"
                className="mt-8"
                onClick={() => {
                    router.back()
                }}
            >
                <ChevronLeftIcon className="size-4" />
                Indietro
            </Button>
        </div>
    )
}
